import Tabby from 'tabbyjs';

document.addEventListener('DOMContentLoaded', () => {
  const tabsEl = document.querySelector('[data-tabs]');
  if (tabsEl) {
    // eslint-disable-next-line no-unused-vars
    const tab = new Tabby('[data-tabs]');

    document.addEventListener('tabby', function (event) {
      console.log(event.target);
    }, false);
  }
})
